<template>
    <ion-card class="floating floating-small"
              style="text-align: center">
        <ion-card-header>
            <ion-card-title>{{ $t('ncrypt.register_page.title') }}</ion-card-title>
        </ion-card-header>

        <ion-card-content>
            <register-form v-on:registered="onRegisterFromModal" v-on:register-error="onRegisterError"/>
        </ion-card-content>
    </ion-card>
</template>

<script>
    import {ApiError} from "@/errors/ApiError";
    import RegisterForm from "./RegisterForm.vue";

    export default {
        name: "Register",
        components: {RegisterForm},
        data() {
            return {
                redirectTo: 'outbox',
            };
        },
        methods: {
            onRegisterFromModal() {
                this.$router.push({name: this.redirectTo});
            },
            onRegisterError(data) {
                new ApiError(data, false);
            },
        },
    }
</script>
